import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Signout } from '../Signout/Signout';
import { BorrarUser } from '../BorrarUser/BorrarUser';
import { ModalCarga } from '../ModalCarga/ModalCarga';
import './Usuario.css';
import { goStripePortal } from '../../firebase/portal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell,
  faStar,
  faUser,
  faAngleDown,
  faAngleUp,
  faCrown,
  faCoins,
  faCircleInfo
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';


export const Usuario = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading, premium, planName } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const goToFavoritos = () => navigate('/favoritos');
  const goToAlertas = () => navigate('/alertas');
  const goToPremium = () => navigate('/premium');
  const goToAffiliateDashboard = () => navigate('/afiliados-dashboard');

  const goStripePortalWithLoading = async () => {
    try {
      setLoading(true);
      await goStripePortal();
    } catch (error) {
      console.error('Error al ir al portal de Stripe:', error);
      alert('Ocurrió un error durante el proceso. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (authLoading || !user) {
    return <ModalCarga />;
  }

  return (
    <div>
      {loading && (
        <ModalCarga/>
      )}
      <div className="usuario">
        <div className="info-y-botones">
          <div className="info-user">
            <div className="user-plan">
              <h1>{user.displayName}</h1>
              <span className="premium-label">{premium ? planName : 'Gratis'}</span>
            </div>
            <p className="puser">{user.email}</p>
            <p className="puser">{user.username}</p>
          </div>

          <div className="servicios-premium user-h2">
            <h2>Servicios Premium</h2>
            <ul>
              {!premium && (
                <>
                  <li>
                    <p className="puser">¡Suscríbete para disfrutar de los servicios Premium!</p>
                  </li>
                  <li>
                    <button className="suscribe-premium" onClick={goToPremium}>
                      <p>
                        <FontAwesomeIcon icon={faCrown} /> Suscribirse
                      </p>
                    </button>
                  </li>
                  <li>
                    <button className="go-premium" onClick={goToAlertas}>
                      <p>
                        <FontAwesomeIcon icon={faBell} /> Mis Alertas
                      </p>
                    </button>
                  </li>
                  <li>
                    <button className="go-premium" onClick={goToPremium}>
                      <p>
                        <FontAwesomeIcon icon={faStar} /> Rastreador de Productos 
                      </p>
                    </button>
                  </li>
                </>
              )}
              {premium && (
                <>
                  <li>
                    <button onClick={goToAlertas}>
                      <p>
                        <FontAwesomeIcon icon={faBell} /> Mis Alertas
                      </p>
                    </button>
                  </li>
                  <li>
                    <button onClick={goToFavoritos}>
                      <p>
                        <FontAwesomeIcon icon={faStar} /> Rastreador de Productos
                      </p>
                    </button>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="botones-user user-h2">
            <h2 onClick={toggleDropdown} className="dropdown-toggle">
              Gestionar Cuenta
              <span>{isOpen ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}</span>
            </h2>
            {isOpen && (
              <ul className="dropdown-list">
                {user.affiliate && (
                  <li>
                    <button onClick={goToAffiliateDashboard}>
                      <p>
                        <FontAwesomeIcon icon={faCoins} /> Gestionar Afiliados
                      </p>
                    </button>
                  </li>
                )}
                {premium && (
                  <li>
                    <button onClick={goStripePortalWithLoading} disabled={loading} className="manage-button">
                      <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <FontAwesomeIcon icon={faUser} />
                        Gestionar suscripción
                        <span className="info-container">
                          <span className="info-icon">
                            <FontAwesomeIcon icon={faCircleInfo} />
                          </span>
                          <div className="info-tooltip">
                            Cancelar suscripción<br />
                            Cambiar de plan<br />
                            Ver historial de facturas
                          </div>
                        </span>
                      </p>
                    </button>
                  </li>
                )}
                <li>
                  <BorrarUser usuario={user} />
                </li>
              </ul>
            )}
          </div>

          <Signout />
        </div>
        <img className="img-perfil" src="/imgs/perfil.jpg" alt="persona con bolsa para comprar" />
      </div>
    </div>
  );
};
